export default "__VITE_ASSET__CGBqFW86__"